import { Button, Modal, Typography } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";

import type { IUser } from "@/v1/types";
import { CreateConnectionForm } from "./CreateConnectionForm";

type Props = {
  user?: IUser;
};

const getTexts = (t: TFunction) => ({
  createBankConnection: t("createBankConnection"),
});

export const CreateConnectionButton = ({ user }: Props) => {
  const { t } = useTranslation("Banking");
  const texts = getTexts(t);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const hideModal = () => setIsModalOpen(false);

  return (
    <>
      <Button type="primary" onClick={showModal} disabled={!user}>
        {texts.createBankConnection}
      </Button>
      {user && (
        <Modal
          visible={isModalOpen}
          onCancel={hideModal}
          footer={null}
          destroyOnClose
          width={600}
        >
          <Typography.Title level={3}>
            {texts.createBankConnection}
          </Typography.Title>
          <CreateConnectionForm
            user={user}
            onCancel={hideModal}
            onSuccess={hideModal}
          />
        </Modal>
      )}
    </>
  );
};
